const canPlayVideoBlob = (file: File) => {
  const video = document.createElement('video')
  return !!file.type && video.canPlayType(file.type) !== ''
}

export default canPlayVideoBlob
